import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEraserSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconEraserSimple"><Path d="M12.3052 3.63383C13.3791 2.55988 15.1203 2.55988 16.1942 3.63383L20.3658 7.8054C21.4398 8.87934 21.4398 10.6205 20.3658 11.6945L14.5602 17.5001L6.49958 9.4394L12.3052 3.63383Z" fill="currentColor"/><Path d="M5.43892 10.5001L3.63358 12.3054C2.55964 13.3793 2.55964 15.1205 3.63358 16.1945L7.80515 20.3661C8.8791 21.44 10.6203 21.44 11.6942 20.3661L13.4996 18.5607L5.43892 10.5001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEraserSimple;
